module.exports = __webpack_public_path__ + "img/p3_3.0ea0e2d5.png";